import { clerkMiddleware } from "@clerk/tanstack-react-start/server";
import { createStart } from "@tanstack/react-start";
import { brandClerkCaptureMiddleware, brandClerkOptions } from "./middleware/brand-clerk.ts";
import { hostnameMiddleware } from "./middleware/hostname.ts";

export const startInstance = createStart(() => ({
  // brandClerkCapture stashes the request's brand Clerk keys first; clerkMiddleware
  // then reads them per-request via brandClerkOptions' getters (so auth() + the SSR
  // clerk state use the clawinstall instance on clawinstall hosts, default elsewhere);
  // hostname detection adds to context last (Clerk middleware doesn't preserve
  // upstream context, so hostname must run after).
  requestMiddleware: [
    brandClerkCaptureMiddleware,
    clerkMiddleware(brandClerkOptions),
    hostnameMiddleware,
  ],
}));
